// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h1[data-v-7348a828]{margin-bottom:-2.5rem}#product-group[data-v-7348a828]{margin-top:-3.8rem}#not-found[data-v-7348a828]{text-align:center}#not-found svg[data-v-7348a828]{color:#f0f0f0;width:35%;height:35%}#not-found h2[data-v-7348a828]{margin-top:2rem;color:#dcdcdc}.breadcrumb-item[data-v-7348a828]:before{float:none;vertical-align:text-top}.breadcrumb-item.breadcrumb-item-dropdown span[data-v-7348a828]{width:available}", ""]);
// Exports
module.exports = exports;
